import { useRef } from 'react';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';

import Button from '@/components/base/Button';
import InfoBanner from '@/components/base/InfoBanner';
// Components
import Modal from '@/components/base/Modal';

const CommentDeleteModal = ({
    isOpen,
    toggle,
    deleteComment,
    isLoading = false,
    isError = false
}) => {
    const { t } = useTranslation('commons');
    const initRef = useRef(null);

    return (
        <Modal open={isOpen} onDismiss={toggle} initialFocus={initRef} className="!z-100">
            <Modal.Body>
                {isError && (
                    <InfoBanner
                        className="mb-8 text-left"
                        title={t('errors:error')}
                        message={t('errors:error_comment_delete')}
                    />
                )}
                <Modal.Title>{t('comment.delete_comment')}</Modal.Title>
                <Modal.Content>{t('comment.delete_comment_confirmation')}</Modal.Content>
                <Modal.Footer divider={false}>
                    <Button variant="secondary" className="w-1/2" onClick={toggle}>
                        {t('commons:no')}
                    </Button>
                    <Button isLoading={isLoading} onClick={deleteComment} className="w-1/2">
                        {t('commons:yes')}
                    </Button>
                </Modal.Footer>
            </Modal.Body>
        </Modal>
    );
};

CommentDeleteModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    deleteComment: PropTypes.func.isRequired,
    isLoading: PropTypes.bool
};

export default CommentDeleteModal;
